import { isPathDisabled } from '@jaymathew/ui-shared/utils/isPathDisabled'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { loginPage, notAuthorized } from 'resources/constants'
import { Role } from 'resources/types'
import { getSelectedCompany } from 'shared/functions/selectedCompanyAccess'
import { useAuthBootstrap } from 'shared/hooks/useAuthBootstrap'
import { useCurrentUser } from 'shared/hooks/useCurrentUser'

interface ProtectedRouteProps {
  userRole?: Role[]
}

const ProtectedRoute = ({ userRole }: ProtectedRouteProps) => {
	const location = useLocation()
	const currentCompany = getSelectedCompany()

	// ✅ Hooks first, always
	const { user: fbUser, initializing } = useAuthBootstrap()
	const { data: currentUser, isLoading, isFetching, isFetched } = useCurrentUser()

	// ⏳ Wait for Firebase to hydrate session
	if (initializing) return null

	// 🔒 Definitely signed out → go to login
	if (!fbUser) {
		return <Navigate to={loginPage} state={{ redirectURL: location }} replace />
	}

	// 👤 Wait for currentUser query (company-scoped) to settle
	if (isLoading || isFetching || !isFetched || !currentUser) {
		return null
	}

	// ✅ Role + path checks
	const disabledPaths = currentCompany?.disabledPagesByRole?.[currentUser.role] ?? []
	const currentPath = location.pathname

	const roleAllowed = !userRole || userRole.includes(currentUser.role)
	const pathAllowed = !isPathDisabled(currentPath, disabledPaths)

	if (roleAllowed && pathAllowed) {
		return <Outlet />
	}

	return <Navigate to={notAuthorized} />
}

export default ProtectedRoute
